import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { useAuth } from 'src/contexts/auth'
import { GeneticEvaluationController } from 'src/controllers/genetic-evaluation.controller'

const geneticEvaluationController = new GeneticEvaluationController()

export function useUploadGeneticEvaluationCsv() {
  const { userFarm: farmId } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (file: FormData) => geneticEvaluationController.uploadCsvFile(farmId!, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getGeneticEvaluationList', farmId] })
      toastSyncSuccess('Dados importados com sucesso!')
    },
    onError: () => {
      toast.error('Não foi possível carregar os dados, tente novamente.')
    }
  })
}
